module.exports = __webpack_public_path__ + "static/home-banner-large-1822d07d63fd0f547b6a53b74de1ad27.jpg";